module.exports = __webpack_public_path__ + "static/media/kiln.9073b636.png";